<template>
  <div class="card shadow-bg">
    <div class="border-0 card-header">
      <h3 class="mb-0">Referrals</h3>
    </div>

    <el-table
      class="table-responsive table-flush"
      header-row-class-name="thead-light"
      empty-text="No Referrals"
      :data="referrals"
    >
      <el-table-column label="Referral" min-width="120px" prop="email" sortable>
        <template v-slot="{ row }">
          <div class="media align-items-center">
            <div class="media-body">
              <span class="font-weight-700 mb-0 text-sm">{{ row.id }}</span>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="Date" min-width="190px" prop="createdAt" sortable>
        <template v-slot="{ row }">
          <div class="align-items-center">
            <span class="mb-0 text-sm">{{
              new Date(row.createdAt).toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                timeZone: 'UTC'
              })
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Event"
        min-width="190px"
        prop="event_type"
        sortable
      >
        <template v-slot="{ row }">
          <div class="align-items-center">
            <span class="mb-0 text-sm text-capitalize">{{
              row.event_type
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Fee" min-width="190px" prop="event_type" sortable>
        <template v-slot="{ row }">
          <div class="align-items-center">
            <span class="mb-0 text-sm"
              >${{ `${Number(row.event_fee).toFixed(2)}` }}</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="Fee Status"
        min-width="190px"
        prop="status"
        sortable
      >
        <template v-slot="{ row }">
          <div class="align-items-center">
            <span class="mb-0 text-sm text-capitalize">{{
              row.invoice
                ? `${row.invoice.status} - ${row.invoice.id}`
                : 'Outstanding'
            }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Table,
  TableColumn
} from 'element-ui'

export default {
  name: 'ReferralTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    referrals: Array
  }
}
</script>

<style scoped></style>
